import { Record, Map as ImmutableMap, fromJS } from 'immutable';
import * as AssociationUpdateType from 'automation-ui-action-features/object-type-properties/AssociationUpdateType';
import AssociationSpec from 'automation-ui-associations/records/AssociationSpec';
import AssociationOptions from 'automation-ui-action-features/object-type-properties/AssociationOptions';
export default class AssociationUpdate extends Record({
  targetSpec: new AssociationSpec(),
  value: {
    type: AssociationUpdateType.COPY_ASSOCIATION
  },
  associationOptions: null
}, 'AssociationUpdate') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    super(propMap.update('targetSpec', targetSpec => new AssociationSpec(targetSpec)).update('value', value => {
      const typedValue = value;
      return typedValue.sourceSpec ? Object.assign({}, typedValue, {
        sourceSpec: new AssociationSpec(typedValue.sourceSpec)
      }) : typedValue;
    }).update('associationOptions', associationOptions => associationOptions ? new AssociationOptions(associationOptions) : null));
  }
  getSourceSpec() {
    return this.get('value').sourceSpec;
  }
  getTargetSpec() {
    return this.targetSpec;
  }
  getBackfillDuration() {
    const associationOptions = this.get('associationOptions');
    if (!associationOptions) {
      return null;
    }
    return associationOptions.getBackfillDuration();
  }
  setBackfillDuration(backfillDuration) {
    return this.update('associationOptions', associationOptions => (associationOptions || new AssociationOptions(fromJS({}))).setBackfillDuration(backfillDuration));
  }
  isEnrolledObjectAssociation() {
    return this.get('value').type === AssociationUpdateType.ENROLLED_OBJECT;
  }
  isCopyAssociation() {
    return this.get('value').type === AssociationUpdateType.COPY_ASSOCIATION;
  }
  static fromSourceAndTargetSpecs(sourceSpec, targetSpec) {
    return new AssociationUpdate({
      targetSpec,
      value: {
        type: AssociationUpdateType.COPY_ASSOCIATION,
        sourceSpec
      }
    });
  }
  static fromEnrolledObjectTargetSpec(targetSpec) {
    return new AssociationUpdate({
      targetSpec,
      value: {
        type: AssociationUpdateType.ENROLLED_OBJECT
      }
    });
  }
}